import type { FC } from 'react';

import type { Grid2Props } from '@mui/material/Unstable_Grid2';
import Grid2 from '@mui/material/Unstable_Grid2';

import Typography from '@mui/material/Typography';

import { DEFAULT_DISPLAY } from '@/constants/default-value/default-value';
import { t } from '@/utils/lang';

interface Props extends Grid2Props {
    label: string[] | string | React.ReactNode;
    value?: string | number | React.ReactNode;
    xs?: number;
}

export const DisplayField: FC<Props> = ({ label, value, xs = 4, ...props }) => {
    let transLabel: any = '';

    if (typeof label === 'string') {
        transLabel = t(label);
    } else if (Array.isArray(label)) {
        if (label.length > 1) {
            transLabel = t(label[0], label[1]);
        } else {
            transLabel = t(label[0]);
        }
    } else {
        transLabel = label;
    }

    return (
        <Grid2 xs={xs} {...props}>
            <Typography
                variant='subtitle2'
                color='text.primary'
                mb={1}
                fontWeight={600}
            >
                {transLabel}
            </Typography>
            <Typography
                variant='subtitle2'
                color='text.primary'
                noWrap
                sx={{ cursor: 'default' }}
                component={'div'}
                title={typeof value === 'string' ? value : undefined}
            >
                {value || DEFAULT_DISPLAY}
            </Typography>
        </Grid2>
    );
};
